import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Banner2 from "../../assets/img/banners/banner2.jpg"
import Banner1 from "../../assets/img/banners/banner1.jpg"
import api from "../../services/api";
import {BaseBackEND}  from "../../services/auth"


class CarouselIndex extends Component {


  state = {
    configuracao:[],
  }

  async componentWillMount(){
    const response = await api.post("/configuracao/show");
    this.setState({ configuracao: response.data
     });

  }



  render() {
    return (
      <React.Fragment>



<div id="carousel-example-1z" class="sitecarousel carousel slide carousel-fade" data-interval="4000" data-ride="carousel">

  <ol class="carousel-indicators">
    <li data-target="#carousel-example-1z" data-slide-to="0" class="active"></li>
    <li data-target="#carousel-example-1z" data-slide-to="1" ></li>
    <li data-target="#carousel-example-1z" data-slide-to="2"></li>
  </ol>
  <div class="carousel-inner" role="listbox">
    
  
    <div class="carousel-item active">
    <a href="/pos-graduacao"><img class="d-block w-100" src={BaseBackEND()+this.state.configuracao.bannersite}
         />
         </a>
    </div>

    
    <div class="carousel-item">
    <a href="/pos-graduacao"><img class="d-block w-100" src={BaseBackEND()+this.state.configuracao.bannersite2}
        />
        </a>
    </div>


    
    <div class="carousel-item">
    <a href="/pos-graduacao"><img class="d-block w-100" src={BaseBackEND()+this.state.configuracao.bannersite3}
        />
        </a>
    </div>


  </div>

  <a class="carousel-control-prev" href="#carousel-example-1z" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carousel-example-1z" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>

</div>






<div id="carousel-example-1z" class="mobilecarousel carousel slide carousel-fade" data-ride="carousel">

  <ol class="carousel-indicators">
    <li data-target="#carousel-example-1z" data-slide-to="0" class="active"></li>
  </ol>
  <div class="carousel-inner" role="listbox">
 
    <div class="carousel-item active">
    <a href="/pos-graduacao"> <img class="d-block w-100" src={BaseBackEND()+this.state.configuracao.bannermobile}
        alt="First slide" /> </a>
    </div>
   

    
  

  </div>

  <a class="carousel-control-prev" href="#carousel-example-1z" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carousel-example-1z" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>

</div>






      </React.Fragment>
       
    );
  }
}

export default withRouter(CarouselIndex);


// WEBPACK FOOTER //
// ./src/pages/content/carrouselindex.js